/*
 * Fileupload
 */

// LE BUT EST D'AVOIR UN MÊME COMPOSANT EN:
//  - Vue
//  - Razor (server side TagHelper)
//  - Vanilla Js

import { alertDialog } from "./dialog.js";
import { fadeIn, fadeOut } from "@sitebuilder/utils/dom.js";

function preventDefaults(e) {
  e.preventDefault();
  e.stopPropagation();
}

function highlight(e, node) {
  node.classList.add("drag-active");
  preventDefaults(e);
}

function deleteFile(node, url, mediaId, callback) {
  const ondelete = () => {
    callback && callback();
    onChangeFiles(node); // always last
  };

  // If no url to post delete => remove current media 
  if (!url) {
    ondelete();
    return;
  }

  const xhttp = new XMLHttpRequest();
  xhttp.open("DELETE", `${url}/${mediaId}`, true);
  xhttp.onreadystatechange = () => {
    if (xhttp.readyState === 4 && xhttp.status >= 200 && xhttp.status < 300) {
      ondelete();
    } else {
      let json = {};
      try {
        json = JSON.parse(xhttp.response);
      } catch {
        /* empty */
      }
      alertDialog("Une erreur s'est produite", `Une erreur s'est produite durant le suppression du fichier : <br/><br/><strong>${Object.values(json?.errors ?? {}).join(", ")}</strong>`);
    }
  };
  xhttp.send();
}

function unhighlight(e, node) {
  node.classList.remove("drag-active");
  preventDefaults(e);
}

const onChangeFiles = (node) => {
  const mediaIds = Array.from(node.querySelectorAll(`input[name="${node.dataset.name}[]"]`));

  const label = node.querySelector("label");

  const multiple = node.querySelector("input[type=file]").hasAttribute("multiple");
  if (mediaIds.length < 1) {
    node.classList.remove("has-files");
    !multiple && fadeIn(label, 200);
  } else {
    multiple ? node.classList.add("has-files") : fadeOut(label, 200, () => node.classList.add("has-files"));
  }
};

const onUploadFiles = (e, node) => {
  const input = e.target;
  // console.log("on change files", input.files);
  const filesNode = node.querySelector(".a-fileupload-files");

  // Loop through files
  for (let i = 0; i < input.files.length; i++) {
    const file = input.files[i];

    const xhttp = new XMLHttpRequest();

    const div = document.createElement("div");
    div.className = "a-fileupload-file";
    div.innerHTML = `<div class="a-fileupload-file-content">
      <div class="a-fileupload-file-title">
        <i class="ico-file"></i><span>${file.name}</span><i class="ico-check"></i>
        <input name="${node.dataset.name}[]" type="hidden" />
      </div>
      <div class="a-loading-bar"><div class="a-progress"></div></div>
    </div>
    <div class="a-fileupload-file-remove"><i class="ico-trash"></i></div>`;

    filesNode.appendChild(div);
    const deleteBtn = div.querySelector(".ico-trash");
    const loadingBar = div.querySelector(".a-loading-bar");
    const progressBar = loadingBar.firstChild;

    deleteBtn.onclick = () => deleteFile(node, node.dataset.deleteUrl, div.querySelector("input").value, () => div.remove());

    xhttp.open("POST", node.dataset.uploadUrl, true);
    const data = new FormData();
    data.append("file", file);

    xhttp.upload.addEventListener("progress", (e) => {
      const percent = (e.loaded / e.total) * 100;
      progressBar.style.width = `${Math.round(percent)}%`;
    });
    xhttp.addEventListener("load", (e) => {
      if (xhttp.status >= 200 && xhttp.status < 300) {
        const media = JSON.parse(e.currentTarget.responseText)[0];
        div.querySelector("input").value = media.id;
        div.querySelector("span").innerHTML = media.name;
        setTimeout(() => {
          input.value = null;
          div.classList.add("success");
          div.querySelector(".ico-check").classList.add("pulse");
          loadingBar.remove();
          onChangeFiles(node);
        }, 1000);
      } else {
        div.remove();
        alertDialog("Une erreur s'est produite", "Une erreur s'est produite durant le téléchargement du fichier.");
        onChangeFiles(node);
      }
    });
    xhttp.onerror = function () {
      alertDialog("Une erreur s'est produite", "Une erreur s'est produite durant le téléchargement du fichier (réseau).");
    };
    xhttp.addEventListener("abort", function () {
      alertDialog("Une erreur s'est produite", "Une erreur s'est produite durant le téléchargement du fichier (abandon).");
    });
    xhttp.send(data);
  }
};

/// 1. create from JS:
const attachFileUpload = (node) => {
  const input = node.querySelector("input[type=file]");
  const multiple = input.hasAttribute("multiple");
  const btn = node.querySelector("button[type=button]");

  input.addEventListener("change", (e) => onUploadFiles(e, node));
  btn.addEventListener("click", () => input.click());

  Array.from(node.querySelectorAll(".a-fileupload-file")).forEach(
    (div) => (div.querySelector(".ico-trash").onclick = () => deleteFile(node, node.dataset.deleteUrl, div.querySelector("input").value, () => div.remove())),
  );

  node.addEventListener("dragenter", (e) => highlight(e, node), false);
  node.addEventListener("dragover", (e) => highlight(e, node), false);
  node.addEventListener("dragleave", (e) => unhighlight(e, node), false);
  node.addEventListener(
    "drop",
    (e) => {
      unhighlight(e, node);

      const dt = e.dataTransfer;
      const files = dt.files;

      if (files.length) {
        if (multiple) {
          // Combine existing files and new files
          const combinedFileList = new DataTransfer();
          Array.from(input.files)
            .concat(Array.from(files))
            .forEach((file) => {
              combinedFileList.items.add(file);
            });
          input.files = combinedFileList.files;
        } else {
          input.files = files;
        }

        // Force Dispatch "onchange" the event
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }
    },
    false,
  );
};

const createFileUpload = (attributes) => {};

const razorFileUpload = {
  selector: ".a-fileupload",
  create: createFileUpload,
  attach: attachFileUpload,
};

export default razorFileUpload;
